import React from 'react';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme: any) => ({
  subHeader: {
    backgroundColor: theme.palette.primary.light,
    borderColor: theme.palette.brand.blueSky,
    borderWidth: 1,
    borderStyle: 'solid',
    borderRadius: theme.spacing(1),
    display: 'flex',
    alignItems: 'center',
    textAlign: 'left',
    marginTop: theme.spacing(5),
    paddingTop: theme.spacing(3.25),
    paddingBottom: theme.spacing(3.25),
    paddingLeft: theme.spacing(5),
    paddingRight: theme.spacing(5),
    width: '100%',
  },
}));

interface Props {
  text: string;
  extraClasses?: string;
}

export default function SubHeader({ text, extraClasses = '' }: Props) {
  const classes = useStyles();
  return (
    <Typography
      variant="subtitle2"
      align="center"
      className={`${classes.subHeader} ${extraClasses}`}
    >
      {text}
    </Typography>
  );
}
